module.exports = __webpack_public_path__ + "1a669d1d89a75b142d90db618b17a7b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/name-male-1.svg
// module id = 87
// module chunks = 0